<template>
  <div class="table-wrapper">
    <b-table
      striped
      hover
      :items="userList"
      :fields="fields"
      :tbody-tr-class="['clickable-row']"
      @row-clicked="openUserDetail"
    >
    </b-table>
    <b-modal
      :title="`User - ${currentRow && currentRow.email}`"
      :id="`user-detail-modal-${id}`"
      hide-footer
      size="xl"
    >
      <user-detail-page
        v-if="currentRow"
        :user-id="currentRow._id"
        @user-updated="handleUserUpdated"
        @user-deleted="handleUserDeleted"
      ></user-detail-page>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import UserDetailPage from '@/views/UserDetailPage.vue'

export default {
  name: 'UserList',
  components: { UserDetailPage },
  inject: ['userStore'],
  props: {
    users: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    const id = _.random(0, 9999999)
    return {
      id: id,
      currentRow: null,
      fields: [
        {
          key: 'email',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'type',
          sortable: true,
        },
        {
          key: 'department',
          sortable: true,
        },
        {
          key: 'phone',
          sortable: true,
        },
        {
          key: 'createdAt',
          label: 'Created',
          sortable: true,
        },
      ],
    }
  },
  computed: {
    userList() {
      return this.users.map(user => {
        const name =
          user.firstName && user.lastName
            ? `${user.firstName} ${user.lastName}`
            : user.firstName || user.lastName || '-'

        return {
          _id: user._id,
          email: user.email,
          name: name,
          type: user.type || '-',
          department: user.department || '-',
          phone: user.phone || '-',
          createdAt: moment(user.createdAt).format('MMM D, YYYY'),
        }
      })
    },
  },
  methods: {
    openUserDetail(user, index, e) {
      this.currentRow = user
      this.$bvModal.show(`user-detail-modal-${this.id}`)
    },
    handleUserUpdated(updatedUser) {
      this.$emit('user-updated', updatedUser)
    },
    handleUserDeleted(userId) {
      this.$bvModal.hide(`user-detail-modal-${this.id}`)
      this.$emit('user-deleted', userId)
    },
  },
}
</script>

<style lang="scss" scoped>
@media print {
  .table-wrapper {
    max-height: inherit;
    overflow: auto;
  }
}
</style>

<style>
.clickable-row {
  cursor: pointer;
}
</style>


